"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PASSWORD_UPDATE_LONG = exports.PASSWORD_UPDATE = exports.PASSWORD_CREATE_LONG = exports.PASSWORD_CREATE = exports.PASSWORD_CONFIRM_LONG = exports.PASSWORD_CONFIRM = exports.PASSWORD = void 0;
var _passwordConstants = _interopRequireDefault(require("../../constants/passwordConstants"));
var _InputPassword = _interopRequireDefault(require("../../elements/input-password/InputPassword"));
var _regex = require("../regex");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var formValidationEmptyMessage = 'Please enter a password';
var formValidationTooLongMessage = 'Sorry, your password is too long, it must contain between 8 and 20 characters. Please try again';
var formValidationInvalidMessage = 'Please enter a password that meets our security standard';
var formValidationNoWhitespaceMessage = 'Please remove any spaces from your password';
var PASSWORD = exports.PASSWORD = {
  component: _InputPassword["default"],
  id: 'password',
  name: 'password',
  label: 'Password',
  type: 'password',
  required: true,
  passwordToggle: true,
  passwordRules: false,
  validationMessageKeys: {
    required: formValidationEmptyMessage,
    maxLength: formValidationTooLongMessage
  },
  extensionProps: {
    autoComplete: 'current-password'
  }
};
var PASSWORD_CREATE = exports.PASSWORD_CREATE = _objectSpread(_objectSpread({}, PASSWORD), {}, {
  id: 'passwordCreate',
  label: 'Password',
  passwordToggle: true,
  passwordRules: true,
  regex: _regex.passwordRegex,
  noWhitespace: true,
  validationMessageKeys: {
    required: formValidationEmptyMessage,
    regex: formValidationInvalidMessage,
    maxLength: formValidationTooLongMessage,
    noWhitespace: formValidationNoWhitespaceMessage
  },
  extensionProps: _objectSpread(_objectSpread({}, PASSWORD.extensionProps), {}, {
    autoComplete: 'new-password'
  })
});
var PASSWORD_UPDATE = exports.PASSWORD_UPDATE = _objectSpread(_objectSpread({}, PASSWORD_CREATE), {}, {
  id: 'passwordUpdate',
  label: 'New password'
});
var PASSWORD_CONFIRM = exports.PASSWORD_CONFIRM = _objectSpread(_objectSpread({}, PASSWORD), {}, {
  id: 'passwordConfirm',
  name: 'passwordConfirm',
  label: 'Repeat new password',
  passwordToggle: true,
  passwordRules: false,
  matchField: 'password',
  regex: _regex.passwordRegex,
  noWhitespace: true,
  validationMessageKeys: {
    required: formValidationEmptyMessage,
    maxLength: formValidationTooLongMessage,
    matchField: 'The two passwords do not match. Please check and try again',
    regex: formValidationInvalidMessage,
    noWhitespace: formValidationNoWhitespaceMessage
  },
  extensionProps: _objectSpread(_objectSpread({}, PASSWORD.extensionProps), {}, {
    autoComplete: 'new-password'
  })
});
var PASSWORD_CREATE_LONG = exports.PASSWORD_CREATE_LONG = _objectSpread(_objectSpread({}, PASSWORD_CREATE), {}, {
  validationMessageKeys: _objectSpread(_objectSpread({}, PASSWORD_CREATE.validationMessageKeys), {}, {
    maxLength: undefined
  }),
  passwordRulesMaxLength: _passwordConstants["default"],
  regex: _regex.passwordRegexLong
});
var PASSWORD_UPDATE_LONG = exports.PASSWORD_UPDATE_LONG = _objectSpread(_objectSpread({}, PASSWORD_UPDATE), {}, {
  validationMessageKeys: _objectSpread(_objectSpread({}, PASSWORD_UPDATE.validationMessageKeys), {}, {
    maxLength: undefined
  }),
  passwordRulesMaxLength: _passwordConstants["default"],
  regex: _regex.passwordRegexLong
});
var PASSWORD_CONFIRM_LONG = exports.PASSWORD_CONFIRM_LONG = _objectSpread(_objectSpread({}, PASSWORD_CONFIRM), {}, {
  validationMessageKeys: _objectSpread(_objectSpread({}, PASSWORD_CONFIRM.validationMessageKeys), {}, {
    maxLength: undefined
  }),
  passwordRulesMaxLength: _passwordConstants["default"],
  regex: _regex.passwordRegexLong
});